import {
    UPDATE_REGISTER_EMAIL,
    UPDATE_REGISTER_PASSWORD,
    UPDATE_REGISTER_ORGANIZATION_NAME,
    UPDATE_REGISTER_FIRST_NAME,
    UPDATE_REGISTER_MIDDLE_NAME,
    UPDATE_REGISTER_LAST_NAME,
    UPDATE_REGISTER_INVITE_CODE,
    UPDATE_REGISTER_STAFF_INVITE_CODE,
    REGISTER_ATTEMPT,
    REGISTER_RESET,
} from 'shared_redux/actions';

export const updateEmail = (email) => ({ type: UPDATE_REGISTER_EMAIL, email });

export const updatePassword = (password) => ({ type: UPDATE_REGISTER_PASSWORD, password });

export const updateOrganizationName = (organization_name) => ({ type: UPDATE_REGISTER_ORGANIZATION_NAME, organization_name });

export const updateFirstName = (firstName) => ({ type: UPDATE_REGISTER_FIRST_NAME, firstName });

export const updateMiddleName = (middleName) => ({ type: UPDATE_REGISTER_MIDDLE_NAME, middleName });

export const updateLastName = (lastName) => ({ type: UPDATE_REGISTER_LAST_NAME, lastName });

export const updateInviteCode = (inviteCode) => ({ type: UPDATE_REGISTER_INVITE_CODE, inviteCode });

export const updateStaffInviteCode = (staffInviteCode) => ({ type: UPDATE_REGISTER_STAFF_INVITE_CODE, staffInviteCode });

export const register = (token, email, password, organization_name, beta, inviteCode, firstName, middleName, lastName, programId) => ({
    type: REGISTER_ATTEMPT,
    token,
    email,
    password,
    organization_name,
    beta,
    inviteCode,
    firstName,
    middleName,
    lastName,
    programId
});

export const resetRegister = () => ({ type: REGISTER_RESET });
